import { useQuery } from "@tanstack/react-query";

import { fetchGrafanaConfig } from "@/api/endpoints/grafana";
import { PlaceholderPage } from "@/components/PlaceholderPage";

export function GrafanaPage() {
  const query = useQuery({ queryKey: ["grafana", "config"], queryFn: fetchGrafanaConfig });

  if (query.isLoading) return null;

  if (!query.data?.configured || !query.data.base_url) {
    return (
      <PlaceholderPage
        title="Grafana"
        roadmapStage="Not configured"
        description="Set GRAFANA_BASE_URL in the backend .env to enable embedding."
      />
    );
  }

  return (
    <div className="flex h-full flex-col gap-2">
      <div className="flex items-center justify-between">
        <p className="text-xs text-text-muted">
          Log in within the frame using your own Grafana credentials — this portal doesn't handle
          Grafana auth.
        </p>
        <a
          href={query.data.base_url}
          target="_blank"
          rel="noreferrer"
          className="text-xs text-accent hover:underline"
        >
          Open in new tab ↗
        </a>
      </div>
      <iframe
        title="Grafana"
        src={query.data.base_url}
        className="h-[80vh] w-full rounded-lg border border-border bg-surface"
      />
    </div>
  );
}
